import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const StudentInfoCard = ({
  student,
  onAddClick,
  balance,
  writeOffRemaining,
}) => {
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  return (
    <Box className='bg-[#FAFBFF] rounded-lg border border-[#F1F1F1] mb-2'>
      <Box className='p-6'>
        <Typography
          className='font-extrabold text-[#2563EB] text-lg inline-block'
          variant='h2'
        >
          Student Details
        </Typography>{' '}
        {writeOffRemaining && (
          <span className='text-red-500'>
            {' '}
            (StudentFee was WrittenOff and marked as No Due)
          </span>
        )}
        <Box className='flex flex-wrap items-center justify-between mt-4'>
          <Box className='flex flex-wrap items-center justify-between flex-1 w-full md:w-auto'>
            <Box className='w-1/2 md:w-1/4 mb-4 md:mb-0'>
              <Box>
                <Typography className='block  text-[#8A92A6] mb-1'>
                  First Name
                </Typography>
                <Typography className='text-[#232D42] font-bold text-[15px]'>
                  {student.firstName}
                </Typography>
              </Box>
            </Box>
            <Box className='w-1/2 md:w-1/4 mb-4 md:mb-0'>
              <Box>
                <Typography className='block  text-[#8A92A6] mb-1'>
                  Last Name
                </Typography>
                <Typography className='text-[#232D42] font-bold text-[15px]'>
                  {student.lastName}
                </Typography>
              </Box>
            </Box>
            <Box className='w-1/2 md:w-1/4 mb-4 md:mb-0'>
              <Box>
                {instituteType?.toLowerCase() == 'college' ? (
                  <>
                    <Typography className='block  text-[#8A92A6] mb-1'>
                      Branch Name
                    </Typography>
                    <Typography className='text-[#232D42] font-bold text-[15px]'>
                      {student.className}
                    </Typography>
                  </>
                ) : instituteType?.toLowerCase() == 'school' ? (
                  <>
                    <Typography className='block  text-[#8A92A6] mb-1'>
                      Class Name
                    </Typography>
                    <Typography className='text-[#232D42] font-bold text-[15px]'>
                      {student.departmentName}
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography className='block  text-[#8A92A6] mb-1'>
                      Department Name
                    </Typography>
                    <Typography className='text-[#232D42] font-bold text-[15px]'>
                      {student.departmentName}
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
            <Box className='w-1/2 md:w-1/4 mb-4 md:mb-0'>
              <Box>
                <Typography className='block  text-[#8A92A6] mb-1'>
                  Total Fee
                </Typography>
                <Typography className='text-[#232D42] font-bold text-[15px]'>
                  ₹{student.totalFees}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box className='w-full md:w-auto mt-2 md:mt-0 flex justify-start md:justify-end'>
            <button
              className={
                `bg-[#2563EB] text-white px-6 py-2 font-medium text-sm rounded ml-0 md:ml-2 shadow-none  transition-colors ` +
                (writeOffRemaining || balance <= 0
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'hover:bg-[#1e4db7]')
              }
              disabled={writeOffRemaining || balance <= 0}
              onClick={onAddClick}
            >
              Add Fee Details
            </button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StudentInfoCard;
